import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const Add = createSvgIcon(
  <path fillRule="evenodd" clipRule="evenodd" d="M6 0H5V5H0V6H5V11H6V6H11V5H6V0Z" />,
  'Add'
)

export default Add
